/**
 * AppFooter — shared footer links rendered on every PageLayout page so the
 * creator program, business listing and legal pages stay discoverable.
 */
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";

export function AppFooter() {
  return (
    <footer className="border-t bg-muted/30 py-10">
      <div className="mx-auto max-w-5xl space-y-6 px-4">
        <div className="rounded-2xl border border-primary/25 bg-primary/5 p-5 text-center shadow-sm sm:text-left">
          <div className="flex flex-col items-center gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0">
              <h2 className="flex items-center justify-center gap-1.5 text-base font-extrabold sm:justify-start">
                <Sparkles className="h-4 w-4 text-primary" /> For creators
              </h2>
              <p className="mt-1 text-sm text-muted-foreground">
                Join the creator program and get featured across Abu Dhabi's best places.
              </p>
            </div>
            <Button asChild className="shrink-0 font-semibold">
              <Link to="/creators/join">Become a Creator</Link>
            </Button>
          </div>
        </div>

        <nav
          className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-muted-foreground"
          aria-label="Footer navigation"
        >
          <Link
            to="/creators/join"
            className="font-semibold text-primary underline hover:no-underline"
          >
            Become a creator
          </Link>
          <span aria-hidden>•</span>
          <Link to="/creators" className="underline hover:no-underline">
            Browse creators
          </Link>
          <span aria-hidden>•</span>
          <Link to="/list-your-business" className="underline hover:no-underline">
            List your business
          </Link>
          <span aria-hidden>•</span>
          <Link to="/terms-of-service" className="underline hover:no-underline">
            Terms of Service
          </Link>
          <span aria-hidden>•</span>
          <Link to="/privacy-policy" className="underline hover:no-underline">
            Privacy Policy
          </Link>
          <span aria-hidden>•</span>
          <Link to="/support" className="underline hover:no-underline">
            Support
          </Link>
        </nav>
        <p className="text-center text-sm text-muted-foreground">© 2026 GoalDigger. Made with ❤️ in the UAE.</p>
      </div>
    </footer>
  );
}
